import { useState, useEffect } from 'react';
import Sidebar from '@/components/layout/Sidebar';
import HarnessTopbar from './HarnessTopbar';

/**
 * HarnessAppLayout - Customer dashboard layout for UI Harness
 * 
 * IMPORTANT: This is ONLY for /__ui-harness routes
 * Identical to AppLayout but without Clerk dependencies
 * 
 * DOES NOT:
 * - Use Clerk components
 * - Make API calls
 * - Handle authentication
 */
export default function HarnessAppLayout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Close sidebar on route change (mobile)
  useEffect(() => {
    setSidebarOpen(false);
  }, [window.location.pathname]);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Sidebar */}
      <Sidebar 
        isOpen={sidebarOpen} 
        onClose={() => setSidebarOpen(false)}
      />

      {/* Main content area */}
      <div className="lg:pl-64">
        {/* Harness Topbar (No Clerk) */}
        <HarnessTopbar variant="customer" onMenuClick={() => setSidebarOpen(true)} />
        
        {/* Page content */}
        <main className="pt-16">
          {children}
        </main>
      </div>
    </div>
  );
}
